module.exports = __webpack_public_path__ + "img/ring-my-barber-salespage-logo.1e95ec16.png";